// src/metaConfig.ts

type MetaEntry = {
  title: string;
  description: string;
};

const metaConfig: Record<string, MetaEntry> = {
  "/": {
    title: "Srisailam Foundation | Education, Health, Women Empowerment & Environment",
    description:
      "Join Srisailam Foundation in transforming lives through education, healthcare, women empowerment, and environmental initiatives. Together, we empower change.",
  },

  "/become-member/": {
    title: "Become a Member | Join Srisailam Foundation for Social Impact",
    description:
      "Join Srisailam Foundation as a member and contribute to impactful initiatives in education, healthcare, women empowerment, and environmental sustainability.",
  },

  "/donate/": {
    title: "Donate Today | Empower Women, Educate Children & Protect the Environment",
    description:
      "Make a meaningful impact with your donation to Srisailam Foundation. Support education, healthcare, women’s empowerment, and environmental protection in India.",
  },

  "/education/": {
    title:
      "Empowering Education for All | Srisailam Foundation – Bridging Learning Gaps Across India",
    description:
      "Transforming lives through inclusive and accessible education. Srisailam Foundation supports students from empowerment-seeking communities through scholarships, digital learning, and mentorship programs across India.",
  },

  "/women-empowerment/": {
    title:
      "Women Empowerment in India | Skill Development, Health & Safety – Srisailam Foundation",
    description:
      "Empowering women through skill training, healthcare, and safety awareness. Srisailam Foundation supports underserved women in India to lead empowered, independent lives with dignity and purpose.",
  },

  "/environment/": {
    title:
      "Environmental NGO in India | Srisailam Foundation – Forest, Water, Wildlife & Climate Action",
    description:
      "Join Srisailam Foundation, a leading environmental NGO in India, committed to forest conservation, clean energy, and water sustainability. Act now to build a greener, climate-resilient future.",
  },

  "/health/": {
    title:
      "Healthcare NGO in India | Srisailam Foundation – Free Medical Camps, Maternal Health & Wellness Programs",
    description:
      "Support community health and well-being through Srisailam Foundation. We deliver free medical camps, vaccinations, maternal care, and health education across rural and low-income communities in India.",
  },

  "/livelihood/": {
    title:
      "Livelihood Empowerment NGO in India | Srisailam Foundation – Skill Development, Microfinance & Rural Sustainability",
    description:
      "Transform lives by supporting sustainable livelihood programs. Srisailam Foundation empowers underserved communities in India with vocational training, microloans, agriculture support, and rural housing solutions.",
  },

  // You can customise these as you wish:
  "/about/": {
    title: "About Srisailam Foundation | Vision, Mission & Impact",
    description:
      "Discover the vision, mission and impact of Srisailam Foundation across education, health, women empowerment, environment and livelihood initiatives in India.",
  },
  "/media/": {
    title: "Media & Gallery | Srisailam Foundation Events & Impact Stories",
    description:
      "View photos and media from Srisailam Foundation’s events, on-ground programs, and community impact initiatives.",
  },
  "/certification": {
    title: "Certifications | Trust & Compliance – Srisailam Foundation",
    description:
      "Explore certifications, registrations, and compliance details that reflect the transparency and credibility of Srisailam Foundation.",
  },
  "/team": {
    title: "Our Team | Leaders & Change-makers – Srisailam Foundation",
    description:
      "Meet the dedicated team behind Srisailam Foundation who are driving social change across education, health, environment, women empowerment and livelihood.",
  },
  "/blogs/": {
    title: "Blogs & Stories | Srisailam Foundation Insights & Updates",
    description:
      "Read blogs, stories and updates from Srisailam Foundation about community projects, impact journeys and social change in India.",
  },
  "/contact/": {
    title: "Contact Srisailam Foundation | Volunteer, Partner or Support",
    description:
      "Get in touch with Srisailam Foundation to volunteer, collaborate, partner or support our initiatives in education, health, women empowerment and environment.",
  },
  "/volunteer": {
    title: "Volunteer with Us | Srisailam Foundation",
    description:
      "Register as a volunteer with Srisailam Foundation and contribute your skills to education, healthcare, women empowerment and environmental programs.",
  },
  "/core-team/": {
    title: "Core Team | Srisailam Foundation Leadership",
    description:
      "Know the core leadership team of Srisailam Foundation working to design and scale impact-driven initiatives across India.",
  },
  "/mentors/": {
    title: "Mentors | Advisors & Guides – Srisailam Foundation",
    description:
      "Meet the mentors and advisors who guide Srisailam Foundation’s strategy, governance and long-term impact.",
  },
  "/privacy-policy/": {
    title: "Privacy Policy | Srisailam Foundation",
    description:
      "Read the privacy policy of Srisailam Foundation to understand how we handle, store, and protect your data and personal information.",
  },
};

export default metaConfig;
